Object.assign(exports, require('./read'))
